module.exports = {
    myProfile: {
        updateBusinessDetailsMessage:
            'Please contact us on <strong><a href="tel:1300665386">1300 665 386</a></strong> or email <strong><a href="mailto:business@woolworths.com.au">business@woolworths.com.au</a></strong> and we\'ll update your business account.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/my-profile.js